const SHINAGAWA_BFF_API_KEY = (() => {
    switch (process.env.REACT_APP_ENV) {
        case "production":
            return process.env.REACT_APP_SHINAGAWA_BFF_API_KEY_PRD;
        case "staging":
            return process.env.REACT_APP_SHINAGAWA_BFF_API_KEY_DEV;
        default:
            return process.env.REACT_APP_SHINAGAWA_BFF_API_KEY_DEV;
    }
})();

const GENE = (() => {
    return "gene";
})();

const AFFILIATE_RECOMMEND = false;

export {SHINAGAWA_BFF_API_KEY, GENE, AFFILIATE_RECOMMEND}


// WEBPACK FOOTER //
// ./src/constants/EnvItems.js